import React from 'react'
import './AdminVerifyModal.css'
import { useVerifyModal } from './hooks/useVerifyModal'

function AdminVerifyModal({ show, onClose, onSuccess }) {
  const {
    nameuser,
    setNameuser,
    password,
    setPassword,
    handleSubmit,
  } = useVerifyModal({ onSuccess, onClose })

  if (!show) return null

  return (
    <div className="admin-modal-backdrop">
      <div className="admin-modal-container">
        <h5 className="admin-modal-title">
          Verificación de Administrador
        </h5>
        <form className="form-signin" onSubmit={handleSubmit}>
          <div className="form-label-group">
            <input
              type="text"
              id="inputAdminUser"
              className="form-control"
              placeholder="Usuario"
              value={nameuser}
              onChange={(e) => setNameuser(e.target.value)}
              required
              autoFocus={true}
            />
            <label htmlFor="inputAdminUser">
              Usuario
            </label>
          </div>
          <div className="form-label-group">
            <input
              type="password"
              id="inputAdminPassword"
              className="form-control"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="inputAdminPassword">
              Contraseña
            </label>
          </div>
          <button className="btn btn-lg btn-info btn-block text-uppercase" type="submit">
            Verificar
          </button>
          <button className="btn btn-lg btn-secondary btn-block text-uppercase mt-2" type="button" onClick={onClose}>
            Cancelar
          </button>
        </form>
      </div>
    </div>
  )
}

export default AdminVerifyModal